import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "./ui/accordion";
import { FAQS } from "../lib/data";
import { Reveal, Overline } from "./Reveal";

export default function FAQ() {
  return (
    <section id="faq" data-testid="faq" className="relative py-12 md:py-16 noise">
      <div className="max-w-[90rem] mx-auto px-6 lg:px-12 grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-4">
          <Reveal>
            <Overline>Questions</Overline>
            <h2 className="mt-5 font-heading text-4xl md:text-5xl font-bold tracking-tight leading-tight">
              Frequently <span className="text-gradient">asked</span>
            </h2>
            <p className="mt-6 text-textsub">Everything you need to know about working with VynFive. Still curious? Just ask VynBot.</p>
          </Reveal>
        </div>
        <div className="lg:col-span-8">
          <Reveal delay={0.1}>
            <Accordion type="single" collapsible className="w-full">
              {FAQS.map((f, i) => (
                <AccordionItem key={i} value={`item-${i}`} data-testid={`faq-${i}`} className="border-line">
                  <AccordionTrigger className="text-left font-heading text-lg hover:text-brand hover:no-underline py-4">
                    {f.q}
                  </AccordionTrigger>
                  <AccordionContent className="text-textsub text-base leading-relaxed pb-5">
                    {f.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
